<template>
  <section class="info-section">
    <div class="core-container info-section__grid">
      <article class="info-card">
        <h3 class="info-card__title">什么是商标转让？</h3>
        <p class="info-card__body">
          商标转让是注册商标专用权的一种重要取得方式。广义上的商标转让是指通过协议转让、接受赠送、继承、继受等方式从原商标注册人处取得其注册商标所有权的行为。转让注册商标，要在转让后6个月以内由转让人和受让人共同向商标主管机关申请转让注册或评估作价。
        </p>
      </article>

      <article class="info-card">
        <h3 class="info-card__title">为什么要选择商标转让？</h3>
        <div class="info-card__features">
          <div
            v-for="item in whyChooseItems"
            :key="item.no"
            class="info-card__feature"
          >
            <span class="info-card__feature-no">{{ item.no }}</span>
            <div>
              <p class="info-card__feature-title">{{ item.title }}</p>
              <p class="info-card__feature-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </article>

      <article class="info-card">
        <h3 class="info-card__title">平台优势</h3>
        <div class="info-card__stats">
          <div
            v-for="stat in platformStats"
            :key="stat.label"
            class="info-card__stat"
          >
            <p class="info-card__stat-value">{{ stat.value }}</p>
            <p class="info-card__stat-label">{{ stat.label }}</p>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { WHY_CHOOSE_ITEMS, PLATFORM_STATS } from '@/mock/home'

export default {
  name: 'InfoPanels',
  data() {
    return {
      whyChooseItems: WHY_CHOOSE_ITEMS,
      platformStats: PLATFORM_STATS
    }
  }
}
</script>

<style scoped>
.info-section {
  padding: 0 0 var(--space-2xl);
  background: transparent;
}

.info-section__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-lg);
}

.info-card {
  background: var(--color-bg-page);
  border-radius: var(--radius-lg);
  padding: var(--space-xl);
  box-shadow: var(--shadow-card);
}

.info-card__title {
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: var(--space-lg);
}

.info-card__body {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  line-height: 1.8;
}

.info-card__features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-lg);
}

.info-card__feature {
  display: flex;
  gap: var(--space-sm);
  align-items: flex-start;
}

.info-card__feature-no {
  font-size: var(--font-size-lg);
  font-weight: 700;
  color: var(--color-accent-orange);
  flex-shrink: 0;
}

.info-card__feature-title {
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--color-primary);
  margin-bottom: var(--space-xs);
}

.info-card__feature-desc {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.info-card__stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-md) var(--space-lg);
}

.info-card__stat {
  text-align: center;
}

.info-card__stat-value {
  font-size: var(--font-size-xl);
  font-weight: 700;
  color: var(--color-primary);
  line-height: 1.2;
}

.info-card__stat-label {
  margin-top: var(--space-xs);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}
</style>
